import { Button, Divider, Grid, Skeleton, Stack } from "@mui/material";
import { useCallback, useEffect } from "react";
import { useEncounter } from "pages/encounter/encounter.provider";
import CoderDiagnosisSection from "./components/coderDiagnosisSection";
import { Sync } from "@mui/icons-material";
import GlobalPopUp from "components/globalPopUp";

const CoderView = () => {
    const {
        isOverride,
        loading,
        getDefaultCoderForm,
        encounterForm,
        openConfirmCode,
        handleIsSure,
        handleCloseCode
    } = useEncounter();

    const { reset } = encounterForm;

    const setDefaultOverwriteIcd10 = useCallback(() => {
        const encounter = encounterForm.getValues();
        const defaultCoderForm = getDefaultCoderForm();
        reset({ ...encounter, overwriteIcd10: defaultCoderForm });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // const [isIcdCodeChange, setIsIcdCodeChange] = useState(false);
    useEffect(() => {
        // * Check Condition Before Reset
        if (!isOverride) {
            setDefaultOverwriteIcd10();
        }
    }, [isOverride, setDefaultOverwriteIcd10]);

    if (loading) {
        return (
            <Stack width="100%" spacing={2}>
                <Stack sx={{ height: "45vh" }}>
                    <Skeleton width="100%" height={130} />
                    <Skeleton width="100%" height={130} />
                    <Skeleton width="100%" height={130} />
                    <Skeleton width="100%" height={130} />
                    <Skeleton width="100%" height={130} />
                </Stack>

                <Divider />

                <Skeleton width="100%" height={40} />
            </Stack>
        );
    }

    return (
        <>
            <GlobalPopUp
                open={openConfirmCode}
                handleClose={() => handleCloseCode(false)}
                handleSure={handleIsSure}
                title={"Are you sure?"}
                description={
                    "The ICD codes have been changed from the original, which may be due to input from either the coder or the doctor. Do you still want to switch tab?"
                }
                note="The ICD code will be updated based on the doctor's input if you switch tabs."
                sureWord={"Confirm"}
                closeWord={"Cancel"}
            />

            <Stack width="100%">
                <Grid container spacing={2}>
                    <Grid
                        item
                        xs={12}
                        display="flex"
                        justifyContent="flex-end"
                        pr={2}
                    >
                        <Button
                            // onClick={setDefaultData}
                            startIcon={<Sync />}
                            color="secondary"
                        >
                            Sync With Doctor DX
                        </Button>
                    </Grid>
                    <CoderDiagnosisSection name="overwriteIcd10.principal" />
                    <CoderDiagnosisSection name="overwriteIcd10.comorbidity" />
                    <CoderDiagnosisSection name="overwriteIcd10.complication" />
                    <CoderDiagnosisSection name="overwriteIcd10.other" />
                    <CoderDiagnosisSection name="overwriteIcd10.externalCause" />
                </Grid>
            </Stack>
        </>
    );
};

export default CoderView;
